<template>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-shipping">
    <div class="vx-col w-full sm:w-3/4 md:w-2/3 lg:w-3/4 xl:w-3/5">
      <vx-card title="Delivery Details" title-color="primary" >
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-6">

               <!--<div class="vx-card__title mb-4">
                  <h5 class="mb-4">Select Delivery Method</h5>
                </div>-->

                <div id="method-component">
                <!--<div class="vx-row">
                  <div class="vx-col w-full lg:w-1/2">
                    <vs-button type="border" class="mt-4 w-full shadow-md" :class="[ methodComponent === 'shipping' ? 'is-active' : '']" @click="methodComponent = 'shipping'; console.log('shipping click')">Shipping</vs-button>
                  </div>
                  <div class="vx-col w-full lg:w-1/2">
                    <vs-button type="border" class="mt-4 w-full shadow-md" :class="[ methodComponent === 'pickup' ? 'is-active' : '']" @click="methodComponent = 'pickup'; console.log('pickup click')">Pickup</vs-button>
                  </div>
                </div>-->

                <vs-divider/>
                  <template>
                    <component :is="methodComponent"></component>
                  </template>
                </div>

               

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import ShippingMethod from './components/shipping.vue'
import PickupMethod   from './components/pickup.vue'
import router from '@/router';  

export default {
  el: '#method-component',
  data() {
    return {
      methodComponent: 'shipping',
      componentsArray: ['shipping', 'pickup']
    };
  },
  components: {
    'shipping': ShippingMethod,
    'pickup': PickupMethod
  // },
  // method: {
  //   submitForm() {
  //     this.$validator.validateAll().then(result => {
  //       if (result) {
  //         alert("form submitted!");
  //         this.$router.push({ name: 'buyer-summary' })
  //       } else {
  //       }
  //     })
  //   }
  },
   methods:{
    
   }
}
</script>

<style>
.vs-button.is-active {background: rgba(var(--vs-primary)) !important; color: #fff;}
@media screen and (max-width:576px) {
    .router-view { padding: 0.5rem !important; }
}
</style>